import React from 'react';
import { usePortalLanguage } from '../../../contexts/PortalLanguageContext';
import { formatCurrencyWhole } from '../../../utils/formatting';
import { formatClientPortalDateOnly } from '../../../utils/clientPortal';
import { getDaysUntilClose } from '../../../utils/portalStatus';

// At-a-glance tiles on the dark-green banner (D-39): each renders only when its field is present.
// The first tile is the closing countdown. The client already knows which side
// of the deal they are on, so there is no Type tile.
function Tile({ label, value }) {
    return (
        <div className="rounded-xl border border-[color:var(--header-chip-border)] bg-[color:var(--header-chip-bg)] px-4 py-3">
            <div className="text-xs font-semibold uppercase tracking-[0.14em] text-[color:var(--header-text-color)]">{label}</div>
            <div className="mt-1 text-base font-semibold text-[color:var(--header-text-color)]">{value}</div>
        </div>
    );
}

function PortalGlanceStrip({ transaction }) {
    const { t: tr, locale } = usePortalLanguage();
    const t = transaction || {};
    const isSeller = t.transactionType === 'Seller';
    const priceRaw = isSeller ? (t.listPrice || t.salePrice) : (t.salePrice || t.listPrice);
    const priceLabel = tr(isSeller ? 'List Price' : 'Price');
    const price = priceRaw ? formatCurrencyWhole(priceRaw) : '';

    const days = getDaysUntilClose(t.closeDate);
    let countdown = '';
    if (days !== null) {
        if (days > 0) countdown = String(days);
        else countdown = tr(days === 0 ? 'Today' : 'Closed');
    }

    const tiles = [];
    if (countdown) tiles.push({ key: 'countdown', label: tr('Days until closing'), value: countdown });
    if (price) tiles.push({ key: 'price', label: priceLabel, value: price });
    if (t.closeDate) tiles.push({ key: 'closing', label: tr('Closing'), value: formatClientPortalDateOnly(t.closeDate, { emptyLabel: '', locale }) });
    if (t.financingType) tiles.push({ key: 'financing', label: tr('Financing'), value: tr(t.financingType) });

    if (tiles.length === 0) return null;

    return (
        <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
            {tiles.map(tile => <Tile key={tile.key} label={tile.label} value={tile.value} />)}
        </div>
    );
}

export default PortalGlanceStrip;
